import React, { useState } from 'react'
import './ForgotPassword.css'
import { BiArrowBack } from 'react-icons/bi'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import axios from 'axios'
import { Baseurl } from '../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import OTPInput from 'otp-input-react'
import { useNavigate } from 'react-router-dom'

export const ForgotPassword = () => {
  const navigate = useNavigate()
  toast.configure()

  const [getOtp, setGetOtp] = useState()

  //to display and hide otp/reset password component
  const [otp, setOtp] = useState(false)
  const [password, setPassword] = useState(false)

  //to show hide password
  const [showPassword, setShowPassword] = useState(false)

  //state to display password/confirm password error
  const [passwordError, setPasswordErr] = useState(false)
  const [confirmPasswordError, setConfirmPasswordError] = useState(false)

  //state to store input values
  const [values, setValues] = useState({
    email: '',
    role: '',
    password: '',
    confirmPassword: '',
  })
  const [OTP, setOTP] = useState('')

  //onChange input
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }

  //to send OTP on entered email
  const submit = async (e) => {
    e.preventDefault()
    await axios
      .post(Baseurl.nodeLocal + 'enduser/sendOTP', {
        email: values.email,
        role: values.role,
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'success1',
          autoClose: 2000,
        })
        setGetOtp(res.data.otp)

        setTimeout(() => {
          setOtp(true)
        }, 2000)
      })
      .catch((error) => {
        if (error.response.status === 0) {
          toast.error(error.message, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: 'error1',
            autoClose: 3000,
          })
        } else {
          toast.error(error.response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            toastId: 'error2',
            autoClose: 3000,
          })
        }
      })
  }

  //to verify OTP
  const verifyOTP = (e) => {
    e.preventDefault()

    if (getOtp === Number(OTP)) {
      toast.success('OTP Verified.', {
        position: toast.POSITION.TOP_RIGHT,
        toastId: 'success2',
        autoClose: 3000,
      })
      setTimeout(() => {
        setPassword(true)
      }, 3000)
    } else {
      toast.error('Invalid OTP!', {
        position: toast.POSITION.TOP_RIGHT,
        toastId: 'error3',
        autoClose: 3000,
      })
    }
  }

  //password validation
  const handleValidation = (evnt) => {
    const passwordInputValue = evnt.target.value.trim()
    const passwordInputFieldName = evnt.target.name
    //for password
    if (passwordInputFieldName === 'password') {
      const uppercaseRegExp = /(?=.*?[A-Z])/
      const lowercaseRegExp = /(?=.*?[a-z])/
      const digitsRegExp = /(?=.*?[0-9])/
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/
      const minLengthRegExp = /.{8,}/
      const passwordLength = passwordInputValue.length
      const uppercasePassword = uppercaseRegExp.test(passwordInputValue)
      const lowercasePassword = lowercaseRegExp.test(passwordInputValue)
      const digitsPassword = digitsRegExp.test(passwordInputValue)
      const specialCharPassword = specialCharRegExp.test(passwordInputValue)
      const minLengthPassword = minLengthRegExp.test(passwordInputValue)
      if (passwordLength === 0) {
        setPasswordErr(true)
      } else if (!uppercasePassword) {
        toast.error('At least one Uppercase', {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error4',
          autoClose: 8000,
        })
        setPasswordErr(true)
      } else if (!lowercasePassword) {
        toast.error('At least one Lowercase', {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error5',
          autoClose: 8000,
        })
        setPasswordErr(true)
      } else if (!digitsPassword) {
        toast.error('At least one digit', {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error6',
          autoClose: 8000,
        })
        setPasswordErr(true)
      } else if (!specialCharPassword) {
        toast.error('At least one Special Characters', {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error7',
          autoClose: 8000,
        })
        setPasswordErr(true)
      } else if (!minLengthPassword) {
        toast.error('Password must contain at least 8 characters', {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error8',
          autoClose: 8000,
        })
        setPasswordErr(true)
      } else {
        setPasswordErr(false)
      }
    }

    const nameRegex = / /

    if (nameRegex.test(evnt.target.value)) {
      toast.error('White or empty space is not allowed.', {
        position: toast.POSITION.TOP_RIGHT,
        toastId: 'error9',
        autoClose: 8000,
      })
    }

    if (
      passwordInputFieldName === 'confirmPassword' ||
      (passwordInputFieldName === 'password' &&
        values.confirmPassword.length > 0)
    ) {
      if (values.confirmPassword !== values.password) {
        toast.error('Confirm password does not match', {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error10',
          autoClose: 5000,
        })
        setConfirmPasswordError(true)
      } else {
        setConfirmPasswordError(false)
      }
    }
  }

  //change password
  const changePassword = async (e) => {
    e.preventDefault()
    await axios
      .post(Baseurl.nodeLocal + 'enduser/changePassword', {
        email: values.email,
        password: values.password,
        role: values.role,
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'success3',
          autoClose: 3000,
        })
        setTimeout(() => {
          navigate('/ADMS')
        }, 3000)
      })

      .catch((error) => {})
  }

  //mouse event to display/hide password
  const onMouseDown = () => {
    setShowPassword(!showPassword)
  }
  return (
    <div className="forgotpassword">
      <div className="container d-flex justify-content-center">
        <div
          className="card mt-5 border border-0 p-5 fpCard"
          style={{ width: '30rem' }}
        >
          <div className="card-body">
            <h3 className="card-title">Reset Password</h3>
            {/* if password is true then it will show the component to change password */}
            {password === true ? (
              <form onSubmit={changePassword}>
                <div className="form-group mt-4">
                  <div className="input-group mb-1">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="col-md-12 form-label"
                    >
                      Enter New Password
                    </label>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="col-md-8 form-control"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      onKeyUp={handleValidation}
                      autoComplete="on"
                      required
                    />
                    <span
                      className="input-group-text"
                      id="basic-addon2"
                      style={{ cursor: 'pointer' }}
                      onMouseDown={onMouseDown}
                      onMouseUp={onMouseDown}
                    >
                      {showPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )}
                    </span>
                  </div>
                </div>
                {passwordError ? (
                  <h6 className="text-danger">{passwordError}</h6>
                ) : (
                  ''
                )}
                <div className="form-group mt-4">
                  <div className="input-group mb-1">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="col-md-12 form-label"
                    >
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      className="col-md-8 form-control"
                      name="confirmPassword"
                      value={values.confirmPassword}
                      onChange={handleChange}
                      onKeyUp={handleValidation}
                      autoComplete="on"
                      required
                    />
                  </div>
                </div>
                {confirmPasswordError ? (
                  <h6 className="text-danger">{confirmPasswordError}</h6>
                ) : (
                  ''
                )}
                {passwordError ||
                confirmPasswordError ||
                values.password === '' ||
                values.confirmPassword === '' ? (
                  <div className="d-grid gap-2 mt-3">
                    <button className="btn btn-primary disabled" type="submit">
                      Submit
                    </button>
                  </div>
                ) : (
                  <div className="d-grid gap-2 mt-3">
                    <button className="btn btn-primary" type="submit">
                      Submit
                    </button>
                  </div>
                )}
              </form>
            ) : otp === true ? (
              <form onSubmit={verifyOTP}>
                {/* if otp is true it will show component to verify otp */}
                <p
                  className="form-text mt-3"
                  style={{ fontSize: '16px', fontWeight: 500 }}
                >
                  Please enter the OTP sent in your email.
                </p>
                <OTPInput
                  value={OTP}
                  onChange={setOTP}
                  autoFocus
                  OTPLength={4}
                  otpType="number"
                  disabled={false}
                  // secure
                />

                <div className="d-grid gap-2 mt-3">
                  <button
                    className={
                      OTP[0] === undefined ||
                      OTP[1] === undefined ||
                      OTP[2] === undefined ||
                      OTP[3] === undefined
                        ? 'btn btn-primary disabled'
                        : 'btn btn-primary'
                    }
                    type="submit"
                  >
                    Verify OTP
                  </button>
                </div>
                <BiArrowBack
                  className="mt-3"
                  onClick={() => setOtp(false)}
                  style={{ cursor: 'pointer', height: 20, width: 20 }}
                />
              </form>
            ) : (
              <form onSubmit={submit}>
                {/* initial component if password and otp both are false to enter email and send an otp in email */}
                <p
                  className="form-text mt-3"
                  style={{ fontSize: '16px', fontWeight: 500 }}
                >
                  Enter the email associated with your account.
                </p>

                <div className="form-group">
                  <label htmlFor="email" className="mb-1">
                    Enter your email
                  </label>
                  <input
                    className="form-control"
                    type="email"
                    id="email"
                    required
                    name="email"
                    onChange={handleChange}
                    value={values.email}
                  />
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="validationCustom04" className="mb-1">
                    Select role
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    name="role"
                    onChange={handleChange}
                    value={values.role}
                    required
                    id="validationCustom04"
                  >
                    <option value="" disabled selected>
                      Open this select menu
                    </option>
                    <option value="Admin">Admin</option>
                    <option value="HR">HR</option>
                    <option value="Accounts">Accounts</option>
                  </select>
                </div>
                <div className="d-grid gap-2 mt-3">
                  <button
                    className={
                      values.email === '' || values.role === ''
                        ? 'btn btn-primary disabled'
                        : 'btn btn-primary'
                    }
                    type="submit"
                  >
                    Submit
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
